/**
 * Supabase Edge Function URL helper.
 * All API calls route through Supabase Edge Functions so the Next.js
 * build can be exported as fully static files (output: 'export').
 */

const SUPABASE_URL = process.env.NEXT_PUBLIC_SUPABASE_URL ?? '';

function edgeFn(slug: string): string {
  return `${SUPABASE_URL}/functions/v1/${slug}`;
}

export const EDGE_FUNCTIONS = {
  oddsFetch: edgeFn('odds-fetch'),
  mailerliteSendPicks: edgeFn('mailerlite-send-picks'),
  mailerliteSubscribe: edgeFn('mailerlite-subscribe'),
  mailerliteSubscriberCount: edgeFn('mailerlite-subscriber-count'),
  picksCreate: edgeFn('picks-create'),
  picksGrade: edgeFn('picks-grade'),
  picksAutoGrade: edgeFn('picks-auto-grade'),
} as const;
